import classNames from 'classnames/bind';
import { FC, PropsWithChildren } from 'react';
import styles from './commonCard.module.scss';

const cx = classNames.bind(styles);

interface Props {
  className?: string;
  isScroll?: boolean;
}

export const CommonCard: FC<PropsWithChildren<Props>> = (props) => {
  const { className, children, isScroll = true } = props;
  return (
    <div className={cx('commonCard', className)}>
      {isScroll ? (
        <div className={cx('scrollArea')}>
          <div className={cx('scrollInner')}>{children}</div>
        </div>
      ) : (
        <> {children}</>
      )}
    </div>
  );
};
